import React, { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const EditBannerModal = ({
  videos,
  onSaveVideos,
  onClose,
  text,
  onSaveText
}) => {
  const [videoList, setVideoList] = useState([...videos]);
  const [newVideoUrl, setNewVideoUrl] = useState("");
  const [bannerTitle, setBannerTitle] = useState(text.title);
  const [bannerDesc, setBannerDesc] = useState(text.description);
  const [buttonText, setButtonText] = useState(text.buttonText);
  const [buttonUrl, setButtonUrl] = useState(text.buttonUrl);

  const handleAddVideo = () => {
    if (newVideoUrl) {
      setVideoList([...videoList, newVideoUrl]);
      setNewVideoUrl("");
    }
  };

  const handleRemove = idx => {
    setVideoList(videoList.filter((_, i) => i !== idx));
  };

const handleSave = async () => {
  const newText = {
    title: bannerTitle,
    description: bannerDesc,
    buttonText: buttonText,
    buttonUrl: buttonUrl
  };

  // 1. Guarda en el estado global de React (como ya lo haces)
  onSaveVideos(videoList);
  onSaveText(newText);

  // 2. Guarda en Firestore
// Cuando guardes:
await setDoc(doc(db, "configuracion", "banner"), {
  videos: Array.isArray(videoList) ? videoList.filter(url => typeof url === "string" && url.startsWith("http")) : [],
  ...newText
});
  // 3. Guarda en localStorage (nuevo paso)
  localStorage.setItem("bannerVideos", JSON.stringify(videoList));
  localStorage.setItem("bannerText", JSON.stringify(newText));
  onClose();
};

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-lg w-full">
        <h2 className="text-2xl font-bold mb-4 text-center">Editar Banner</h2>
        <label className="block font-bold mb-1 mt-2">Título</label>
        <input
          className="w-full mb-2 p-2 border rounded"
          value={bannerTitle}
          onChange={e => setBannerTitle(e.target.value)}
        />
        <label className="block font-bold mb-1">Descripción</label>
        <textarea
          className="w-full mb-2 p-2 border rounded"
          value={bannerDesc}
          onChange={e => setBannerDesc(e.target.value)}
        />
        <label className="block font-bold mb-1">Texto del botón</label>
        <input
          className="w-full mb-2 p-2 border rounded"
          value={buttonText}
          onChange={e => setButtonText(e.target.value)}
        />
        <label className="block font-bold mb-1">URL del botón</label>
        <input
          className="w-full mb-2 p-2 border rounded"
          value={buttonUrl}
          onChange={e => setButtonUrl(e.target.value)}
        />
        <label className="block font-bold mb-1 mt-4">Videos del Banner (URL)</label>
        <ul className="mb-2 space-y-2">
          {videoList.map((url, idx) => (
            <li key={idx} className="flex items-center gap-2">
              <video src={url} className="w-24 h-12 rounded shadow" controls />
              <span className="text-xs break-all flex-1">{url}</span>
              <button onClick={() => handleRemove(idx)} className="text-red-500 hover:text-red-700 font-bold text-lg">✖</button>
            </li>
          ))}
        </ul>
        <div className="flex gap-2 mb-4">
          <input
            type="url"
            value={newVideoUrl}
            onChange={e => setNewVideoUrl(e.target.value)}
            placeholder="Nueva URL de video"
            className="flex-1 px-3 py-2 border rounded"
          />
          <button onClick={handleAddVideo} className="bg-green-500 text-white px-4 rounded-lg font-bold hover:bg-green-600">Agregar</button>
        </div>
        <div className="flex gap-4 justify-end">
          <button onClick={handleSave} className="bg-blue-600 text-white px-6 py-2 rounded-lg font-bold hover:bg-blue-700">Guardar</button>
          <button onClick={onClose} className="text-gray-600 px-4">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default EditBannerModal;
